'use strict';

$(document).ready(function () {

  window.addEventListener('popstate', function () {
    location.reload();
  });

  checkScreenSize();

  $('#navbar-lps a').on('click', function (e) {

    e.preventDefault();

    var $currentLink = $(this);
    var $navItem = $currentLink.parents('#navbar-lps');

    if (!$currentLink.hasClass('active')) {
      $navItem.find('a.active').removeClass('active');
      $currentLink.addClass('active');
    }
  });

  function checkScreenSize() {
    if (window.screen.width <= 480) {
      if ($("#card-lp-content-display").hasClass("row")) {
        $("#card-lp-content-display").removeClass("row");
        $("#card-lp-content-display").addClass("column");
      }
    }
  }
});